import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import Refresh from '@mui/icons-material/Refresh';
import { useTranslation } from 'react-i18next';
import { Chart } from '@totalsoft/rocket-ui';
import { Grid, useTheme, alpha } from '@mui/material';
import { getChartColors } from 'components/dashboard/utils';
import { ChartPaperContainer, ChartRefreshButton, ChartWrapper } from './AverageChartsStyles';

const AverageTimeStatesChart = ({ averageTimeStatesData, loadAverageTimeStates }) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const colors = getChartColors(theme.palette.primary.main, averageTimeStatesData.labels.length);

  const data = {
    labels: averageTimeStatesData.labels,
    datasets: [
      {
        data: averageTimeStatesData.series[0],
        fill: true,
        backgroundColor: alpha(colors[0], 0.75),
        borderColor: alpha(colors[0], 0.9)
      }
    ]
  };
  const [showFooterArea, setShowFooterArea] = useState(false);
  const handleChartHover = useCallback(() => {
    setShowFooterArea(true);
  }, []);

  const handleChartLeave = useCallback(() => {
    setShowFooterArea(false);
  }, []);

  return (
    <ChartPaperContainer onMouseEnter={handleChartHover} onMouseLeave={handleChartLeave}>
      <Grid container alignItems='center'>
        <ChartWrapper item xs={12} translate={showFooterArea}>
          <Chart
            title={t('Dashboard.StateTimes')}
            type='bar'
            data={data}
            cardProps={{
              sx: {
                height: '100%'
              }
            }}
            chartprops={{ color: theme.palette.primary.main }}
            height={200}
            options={{
              maintainAspectRatio: false,
              elements: {
                line: {
                  tension: 0.4
                }
              },
              plugins: {
                legend: {
                  display: false
                },
                tooltip: {
                  callbacks: {
                    label: function () {
                      return this.dataPoints[0]?.formattedValue;
                    }
                  }
                }
              }
            }}
          />
        </ChartWrapper>
        {showFooterArea && (
          <Grid container>
            <Grid item xs={12}>
              <ChartRefreshButton variant='text' tooltip={t('Dashboard.Refresh')} onClick={loadAverageTimeStates} size='tiny'>
                <Refresh fontSize='small' />
              </ChartRefreshButton>
            </Grid>
          </Grid>
        )}
      </Grid>
    </ChartPaperContainer>
  );
};

AverageTimeStatesChart.propTypes = {
  averageTimeStatesData: PropTypes.object,
  loadAverageTimeStates: PropTypes.func
};

export default AverageTimeStatesChart;
